// @ts-nocheck
// tslint:disable
export let $location = {
  href: '',
  protocol: '',
  host:''
};
